var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 19,
    viewBox: "0 0 30 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_372_2975)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 0.5C16.1603 0.5 17.2731 0.960936 18.0936 1.78141C18.9141 2.60188 19.375 3.71468 19.375 4.875C19.375 6.03532 18.9141 7.14812 18.0936 7.96859C17.2731 8.78906 16.1603 9.25 15 9.25C13.8397 9.25 12.7269 8.78906 11.9064 7.96859C11.0859 7.14812 10.625 6.03532 10.625 4.875C10.625 3.71468 11.0859 2.60188 11.9064 1.78141C12.7269 0.960936 13.8397 0.5 15 0.5ZM6.25 3.625C6.95 3.625 7.6 3.8125 8.1625 4.15C7.975 5.9375 8.5 7.7125 9.575 9.1C8.95 10.3 7.7 11.125 6.25 11.125C5.25544 11.125 4.30161 10.7299 3.59835 10.0267C2.89509 9.32339 2.5 8.36956 2.5 7.375C2.5 6.38044 2.89509 5.42661 3.59835 4.72335C4.30161 4.02009 5.25544 3.625 6.25 3.625ZM23.75 3.625C24.7446 3.625 25.6984 4.02009 26.4017 4.72335C27.1049 5.42661 27.5 6.38044 27.5 7.375C27.5 8.36956 27.1049 9.32339 26.4017 10.0267C25.6984 10.7299 24.7446 11.125 23.75 11.125C22.3 11.125 21.05 10.3 20.425 9.1C21.5 7.7125 22.025 5.9375 21.8375 4.15C22.4 3.8125 23.05 3.625 23.75 3.625ZM6.875 16.4375C6.875 13.85 10.5125 11.75 15 11.75C19.4875 11.75 23.125 13.85 23.125 16.4375V18.625H6.875V16.4375ZM0 18.625V16.75C0 15.0125 2.3625 13.55 5.5625 13.125C4.825 13.975 4.375 15.15 4.375 16.4375V18.625H0ZM30 18.625H25.625V16.4375C25.625 15.15 25.175 13.975 24.4375 13.125C27.6375 13.55 30 15.0125 30 16.75V18.625Z",
    fill: "#00FF7F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_372_2975"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountGroup);
export default __webpack_public_path__ + "static/media/account-group.9f7e03ed503ae1c71bb5705002e3f296.svg";
export { ForwardRef as ReactComponent };